import { FormRestructureEvent } from "./FormRestructureEvent";

export * from "./FormRestructureEntry";
export * from "./FormRestructureEvent";

/**
 * @param {HTMLFormElement} form 
 */
export function addRestructureObserver(form) {
  const formFieldElementObserver = new MutationObserver(entries => {
    const event = new FormRestructureEvent(form, false);
    event.populate(entries);
    if (!event.isEmpty) {
      form.dispatchEvent(event);
    }
  });
  
  formFieldElementObserver.observe(form, { subtree: true, childList: true })

  const event = new FormRestructureEvent(form, true);
  event.populate(form);
  if (!event.isEmpty) {
    form.dispatchEvent(event);
  }
}
